import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PredictionData {
  movies: any[];
  model_id: string;
  timestamp: string;
  detailed_scores?: any[];
  grouped_scores?: any[];
}

interface PredictionStore {
  predictionResult: PredictionData | null;
  isLoading: boolean;
  error: string | null;
  
  savePrediction: (data: any) => void;
  clearPrediction: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const usePredictionStore = create<PredictionStore>()(
  persist(
    (set, get) => ({
      predictionResult: null,
      isLoading: false,
      error: null,

      savePrediction: (data: any) => {
        try {
          const predictionData: PredictionData = {
            movies: data.movies || [],
            model_id: data.model_id || '',
            timestamp: new Date().toISOString(),
            detailed_scores: data.detailed_scores || [],
            grouped_scores: data.grouped_scores || []
          };

          set({
            predictionResult: predictionData,
            error: null
          });
        } catch (error) {
          const errorMessage = error instanceof Error ? error.message : 'Failed to save prediction';
          set({ error: errorMessage });
          console.error('Error saving prediction:', error);
        }
      },

      clearPrediction: () => {
        set({ 
          predictionResult: null, 
          error: null 
        });
      },

      setLoading: (loading: boolean) => {
        set({ isLoading: loading });
      },

      setError: (error: string | null) => {
        set({ error });
      }
    }),
    {
      name: 'prediction-storage',
      partialize: (state) => ({ predictionResult: state.predictionResult })
    }
  )
);